import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '6a1dc058f06a61a5d47c0c1e';
declare global {
  interface Window {
    pixelId?: string;
  }
}
export function UtmifyPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const loadPixel = () => {
      if (document.querySelector('script[src="https://cdn.utmify.com.br/scripts/pixel/pixel.js"]')) {
        return;
      }
      window.pixelId = PIXEL_ID;
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
      document.head.appendChild(script);
    };
    const idle: any = (window as any).requestIdleCallback;
    if (typeof idle === 'function') {
      idle(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return null;
}